import {
  FEATURED_OFFERS_120X90_GET_FAILURE, FEATURED_OFFERS_120X90_GET_SUCCESS,
} from '../actions/types';

import featuredOffers120x90Config from '../configs';

const initialState = {
  config: featuredOffers120x90Config,
  defaults: {
    isLoaded: false,
    isLoading: false,
    data: [],
  },
};

const featuredOffers120x90 = (state = initialState, action) => {
  const namespaceId = action?.options?.namespace || action?.context?.options?.namespace || 'default';
  const namespace = `namespace-${namespaceId}`;
  const { defaults } = state;
  const { [namespace]: namespaceState = defaults } = state;

  switch (action.type) {
    case FEATURED_OFFERS_120X90_GET_SUCCESS: {
      const { response } = action.payload;

      return {
        ...state,
        [namespace]: {
          ...namespaceState,
          data: response,
          isLoading: false,
          isLoaded: true,
        },
      };
    }
    case FEATURED_OFFERS_120X90_GET_FAILURE: {
      return {
        ...state,
        [namespace]: {
          ...namespaceState,
          data: [],
          isLoading: false,
          isLoaded: true,
        },
      };
    }
    default: {
      const { options = {} } = action;
      // Handle setting isLoading to true for raw OCAPI action
      if (options.success === FEATURED_OFFERS_120X90_GET_SUCCESS) {
        return {
          ...state,
          [namespace]: {
            ...namespaceState,
            isLoading: true,
          },
        };
      }

      return state;
    }
  }
};

export default featuredOffers120x90;
